const STOP_WORDS = new Set([
    "a","an","the","and","or","but","in","on","at","to","for","of","with",
    "by","from","is","are","was","were","be","been","being","have","has",
    "had","do","does","did","will","would","could","should","may","might",
    "shall","can","need","i","you","he","she","it","we","they","this","that",
    "these","those","my","your","his","her","its","our","their","me","him",
    "us","them","what","which","who","whom","when","where","why","how",
    "not","no","so","if","as","up","out","then","than","about","into",
    "more","also","just","all","any","some","such","there","here","now",
]);

function stripHtml(html) {
    return html
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<\/p>/gi, " ")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/\s+/g, " ")
        .trim();
}

function tokenize(text) {
    return text.toLowerCase().match(/\b[a-z']{2,}\b/g) || [];
}

function sentenceSplit(text) {
    return text
        .match(/[^.!?]+[.!?]+["']?|[^.!?]+$/g)
        ?.map(s => s.trim())
        .filter(s => s.length > 20) || [];
}

export function summarize(html, maxSentences = 3) {
    const text = stripHtml(html);
    if (!text) return "";

    const sentences = sentenceSplit(text);
    if (sentences.length <= maxSentences) return sentences.join(" ");

    // Count word frequencies (excluding stop words)
    const freq = {};
    const allWords = tokenize(text).filter(w => !STOP_WORDS.has(w));
    for (const word of allWords) freq[word] = (freq[word] || 0) + 1;

    // Normalise by max frequency
    const maxFreq = Math.max(...Object.values(freq), 1);
    for (const w in freq) freq[w] /= maxFreq;

    // Score each sentence
    const scored = sentences.map((sentence, index) => {
        const words = tokenize(sentence).filter(w => !STOP_WORDS.has(w));
        const score = words.reduce((sum, w) => sum + (freq[w] || 0), 0) / (words.length || 1);
        return {sentence, score, index};
    });

    // Pick top N, restore original order
    return scored
        .sort((a, b) => b.score - a.score)
        .slice(0, maxSentences)
        .sort((a, b) => a.index - b.index)
        .map(s => s.sentence)
        .join(" ");
}

export function extractKeywords(html, max = 8) {
    const text = stripHtml(html);
    if (!text) return [];

    const freq = {};
    const words = tokenize(text).filter(w => !STOP_WORDS.has(w) && w.length > 3);
    for (const word of words) freq[word] = (freq[word] || 0) + 1;

    return Object.entries(freq)
        .sort((a, b) => b[1] - a[1])
        .slice(0, max)
        .map(([word]) => word);
}

export function readingTime(html) {
    const text = stripHtml(html);
    const wordCount = text.split(/\s+/).filter(Boolean).length;
    const minutes = Math.ceil(wordCount / 200);
    return minutes < 1 ? "< 1 min read" : `${minutes} min read`;
}
